<template>
    <div class="bg-light">
        <Loading :show="loading" />
        <div class="container" v-if="!loading">
            <div class="row">
                <div class="col-12 d-flex justify-content-center align-items-center" style="height: 100vh;">
                    <div class="text-center" style="width: 100%">
                        <img v-if="logoSrc" class="mb-4" :src="logoSrc" style="max-height: 120px; max-width: 100%; object-fit: contain;"/>
                        <b-row class="mt-4">
                            <b-col md="6" class="mt-4"><h3 class="text-md-right text-center">{{ $t('document_verify') }}</h3></b-col>
                            <b-col md="6" class="mt-4">
                                <b-alert v-if="fileExists" class="text-left" show variant="danger">
                                    <i class="ri-information-fill" style="font-size: 16px"></i>&nbsp;
                                    <span>{{ fileExists }}</span>
                                </b-alert>
                                <b-alert v-if="verifiedFile" class="text-left" show variant="success">
                                    <i class="ri-shield-check-line" style="font-size: 16px"></i>&nbsp;
                                    <span>"{{ verifiedFile }}" </span>
                                    <span v-if="downloadCheck">{{ $t('downloaded') }}</span>
                                    <span v-if="!downloadCheck">{{ $t('document_verified') }}</span>
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-if="verifiedFile">
                            <b-col md="12" class="d-flex justify-content-center align-items-center">
                                <b-button v-if="!downloadCheck" @click="download" variant="primary">{{$t('document_download')}}</b-button>
                                <b-button v-if="downloadCheck" variant="success">
                                    <i class="ri-check-line" style="font-size: 32px"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QRVerificationService from "@/services/QRVerificationService";
import Loading from "@/components/elements/Loading";

export default {
    components: {
        Loading
    },
    metaInfo() {
        return {
            title: this.$t('document_verify')
        }
    },
    data() {
        return {
            loading: true,
            fileExists: null,
            verifiedFile: null,
            verifiedFileExtension: null,
            downloadCheck: false
        }
    },
    computed: {
        logoSrc() {
            return this.$store.getters['dashboard/getImage']('document-logo.png');
        }
    },
    methods: {
        getData() {
            QRVerificationService.get(this.$route.params.filename).then(response => {
                let fileNameSplit = response.headers.file_name.split('.')
                let fileName;
                if (fileNameSplit.length > 0) {
                    fileName = fileNameSplit[0]
                    this.verifiedFileExtension = response.headers.file_extension
                }else{
                    fileName = response.headers.fileName
                }
                this.verifiedFile = fileName
            }).catch(e => {
                this.fileExists = this.$t('api.' + e.data.message)
            }).finally(() => {
                this.loading = false
            })
        },

        download(){
            QRVerificationService.get(this.$route.params.filename, 'download').then(response => {
                this._downloadFile2(response, this.verifiedFileExtension?this.verifiedFile+'.'+this.verifiedFileExtension:this.verifiedFile)
               // this._downloadFile(response, this.verifiedFileExtension?this.verifiedFile+'.'+this.verifiedFileExtension:this.verifiedFile)
                this.downloadCheck = true
            }).catch(e => {
                this.fileExists = this.$t('api.' + e.data.message)
            })
        }
    },

    async created() {
        this.loading = true
        try {
            await this.$store.dispatch("dashboard/getAppImages")
        } catch (e) {}
        this.getData()
    }
}
</script>

